<script>
import lazyLoadComponent from '@router/lazyload-component'
import { authComputed } from '@state/helpers'
import Layout from '@layouts/main'
import MemberFilterForm from './components/MemberFilterForm.vue'

const conditionList = (list) => {
  return list.filter(({ condition }) => {
    if (condition) return condition()
    return true
  })
}
export default {
  page: {
    title: '會員管理',
    meta: [{ name: 'description', content: 'Member List' }],
  },
  components: {
    Layout,
    MemberFilterForm,
  },
  data() {
    return {
      activeTab: this.$route.params.activeTab || this.$route.query.type || '0',
      sellShow: false,
      openMemberFilterWindowStatus: false,
      memberLevelList: [],
      tagList: [],
      memberFilterData: {
        gender: 'female',
        birthdayMonth: '',
        monthsWithoutOrder: '',
        lineNotifyStatus: '',
        memberLevelIds: '',
        tagIds: [],
        block: '',
      },
    }
  },
  computed: {
    ...authComputed,
    tabList() {
      return conditionList([
        {
          title: '會員管理',
          alias: '0',
          isOpen: true,
          component: () => lazyLoadComponent(import('./list')),
        },
        {
          title: '會員等級設定',
          alias: '1',
          condition: () => {
            return this.$hasMemberLevel()
          },
          component: () => lazyLoadComponent(import('./DetailMemberLevel')),
        },
      ])
    },
  },
  watch: {
    activeTab(value) {
      this.$route.params.activeTab = this.activeTab
      if (value === '1') {
        this.sellShow = true
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    openMemberFilterWindow(data) {
      const { memberLevelList, tagList } = data
      this.memberLevelList = memberLevelList
      this.tagList = tagList
      this.openMemberFilterWindowStatus = true
    },
    async tryToSearchFilter(filterData) {
      await this.$refs.member.tryToSearch(filterData)
      this.openMemberFilterWindowStatus = false
    },
  },
}
</script>

<template>
  <Layout>
    <div class="h-100 position-relative">
      <el-tabs v-model="activeTab" stretch type="border-card" class="isStyleBase">
        <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="tab.alias"> </el-tab-pane>
      </el-tabs>
      <component :is="tabList[activeTab].component" ref="member" :sell-show="sellShow" @openMemberFilterWindow="openMemberFilterWindow"></component>

      <MemberFilterForm v-if="openMemberFilterWindowStatus" :member-level-list="memberLevelList" :tag-list="tagList" @close="openMemberFilterWindowStatus = false" @search="tryToSearchFilter" />
    </div>
  </Layout>
</template>

<style lang="scss">
.member-filter-window {
  min-height: 100%;
  background: #fff;
  z-index: 10;

  a,
  a:visited {
    color: #72767b;
  }

  .el-icon-close {
    font-size: 20px;
  }

  .half-item {
    width: 47.5%;
  }

  .btn-group {
    .el-button {
      width: 47.5%;
    }
  }

  .radio-group {
    .el-radio .is-bordered {
      height: auto;
    }
  }
}
</style>
